import React, { useState } from "react";
import { Card, Button, Collapse, Badge } from "reactstrap";
import { useTranslation } from "react-i18next";

const TrainingCard = ({ training, order, onWatch }) => {
  const [collapse, setCollapse] = useState(false);
  const { t } = useTranslation();

  return (
    <Card className="question d-flex mb-4">
      <div
        className="d-flex flex-grow-1 min-width-zero c-pointer"
        onClick={() => setCollapse(!collapse)}
      >
        <div className="card-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center">
          <div className="list-item-heading mb-0 truncate w-80 mb-1 mt-1">
            <span className="heading-number d-inline-block">{order + 1}</span>
            <strong>{training.title}</strong>
            <Badge
              color="info"
              className="ml-2 text-white"
              style={{ fontSize: "0.7rem" }}
            >
              {t("training")}
            </Badge>
          </div>
          {training.playlist && (
            <span className="text-muted small mr-4">
              {training.playlist.length} {t("videos")}
            </span>
          )}
        </div>
        <div className="custom-control custom-checkbox pl-1 align-self-center pr-4">
          <Button
            outline
            color="theme-3"
            className={`icon-button ml-1 rotate-icon-click ${collapse ? "rotate" : ""}`}
            onClick={(e) => {
              e.stopPropagation();
              setCollapse(!collapse);
            }}
          >
            <i
              className={
                collapse ? "simple-icon-arrow-up" : "simple-icon-arrow-down"
              }
            />
          </Button>
        </div>
      </div>

      <Collapse isOpen={collapse}>
        <div className="card-body pt-0">
          {training.description && (
            <p className="text-muted mb-3">{training.description}</p>
          )}
          <strong>{t("playlist")}</strong>
          <ul className="list-unstyled mt-2">
            {training.playlist &&
              training.playlist.map((item, idx) => (
                <li
                  key={idx}
                  className="d-flex align-items-center justify-content-between mb-2 p-2"
                  style={{ background: "#f8f8f8", borderRadius: 4 }}
                >
                  <span>
                    <i className="simple-icon-film mr-2" />
                    {item.name || `${t("video")} ${idx + 1}`}
                  </span>
                  <Button
                    color="primary"
                    size="sm"
                    onClick={() =>
                      onWatch(
                        item.url,
                        item.name ||
                          `${training.title} — ${t("video")} ${idx + 1}`,
                      )
                    }
                  >
                    <i className="simple-icon-control-play mr-1" />
                    {t("watch")}
                  </Button>
                </li>
              ))}
          </ul>
        </div>
      </Collapse>
    </Card>
  );
};

export default TrainingCard;
